import React from 'react';
import { SEO } from '@olo-web/components/atoms/SEO';

const descBlockers = ['feature', 'recommend', 'favorite'];
const defaultKeywords = [
  'online ordering',
  'restaurant',
  'pickup',
  'delivery',
  'curbside',
  'dine in',
];

interface MenuMetaHeaderProps {
  merchantData?: any;
  merchantGroupData?: any;
  logoUrl?: string;
  backgroundUrl?: string;
  menuData?: Array<{ name: string; [key: string]: any }>;
  merchantId?: string;
}

export const MenuMetaHeader = ({
  merchantData,
  merchantGroupData,
  logoUrl,
  backgroundUrl,
  menuData,
  merchantId,
}: MenuMetaHeaderProps) => {
  const menu = menuData;

  // Direct computation instead of useMemo for SSR compatibility
  const menuGroupNames = (() => {
    if (!menu) return [];
    return menu.reduce((acc, curr) => {
      const lcName = curr?.name.toLowerCase();
      if (descBlockers.some((b) => lcName.includes(b))) return acc;
      return [...acc, lcName];
    }, []);
  })();

  const description = (() => {
    if (!merchantGroupData) return 'Order delicious food online';
    const names = merchantGroupData?.merchants?.reduce((acc, curr, idx, arr) => {
      const len = arr.length;
      if (idx === 0 && len < 2) return curr?.name;
      if (idx === len - 1) return acc + '& ' + curr?.name;
      return acc + curr?.name + ', ';
    }, '');
    let desc = 'Order';
    if (menuGroupNames?.length) {
      desc += ' ' + menuGroupNames.slice(0, 4).join(', ');
      desc += ' and more';
    }
    if (names?.length) {
      desc += ' from ' + names;
    }
    return desc;
  })();

  const keywords = (() => {
    const kw = defaultKeywords.slice();
    if (menuGroupNames?.length) {
      menuGroupNames.forEach((n) => kw.unshift(n));
    }
    return kw.join(',');
  })();

  return (
    <SEO
      title={
        merchantData?.name
          ? `Order from ${merchantData.name}`
          : merchantGroupData?.name
          ? `Order from ${merchantGroupData.name}`
          : undefined
      }
      description={description}
      keywords={keywords}
      menuData={menu}
      merchantData={merchantData}
      merchantGroupData={merchantGroupData}
      logoUrl={logoUrl}
      backgroundUrl={backgroundUrl}
      merchantId={merchantId}
    />
  );
};
